import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { PadraoService } from '../service/padrao.service';
import { ObservableLotacao } from '../util/observable-util';
import { AuthService, User } from '@basis/angular-components';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {

  code: any;
  token: string = localStorage.getItem('token');
  returnIsValid = false;
  authService: AuthService<User>;
  constructor(
    private router: Router,
    private lotacaoService: ObservableLotacao,
    private service: PadraoService,
    auth: AuthService<User>) {
    this.code = window.location.search.substring(1).split('=')[1];
    this.authService = auth;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.token == null && this.code == null) {
      window.location.href = `${environment.apiEndpoint}/api/Autenticar/`;
    } else if (this.token !== null) {
      return this.verificarPermissoes(state);
    } else if (this.code !== null) {
      return this.obterToken();
    }
  }
  canActivateChild = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => this.canActivate(route, state);

  verificarPermissoes(state: RouterStateSnapshot) {
    return this.lotacaoService.getLotacao.map(permissoes => {
      if (permissoes.text != undefined) {
        if (permissoes.text.isLoaded) {
          if (permissoes.text.perfilDTO == null) {
            this.returnIsValid = true;
            this.code = null;
            this.router.navigate(['/erro/403']);
            return false;
          }
          const actionRegex = /\/?(?:.*)\/(.*)\/(editar|cadastrar|visualizar|historico|relatorio|enviar-cadastro)(?:.*)$/;
          const listRegex = /\/([^\/]*)$/;
          var routeInfo = actionRegex.exec(state.url);
          var action = "CONSULTAR";
          var temPerfil = null;
          if (routeInfo != null) {
            switch (routeInfo[2]) {
              case "editar":
                action = "EDITAR";
                break;
              case "cadastrar":
                action = "INSERIR";
                break;
            }
          } else {
            routeInfo = listRegex.exec(state.url);
          }
        }
      }
      return true;
    });
  }

  obterToken() {
    return this.service.ObterToken(this.code).map(token => {
      localStorage.setItem('token', token.access_Token);
      this.code = null;
      window.location.href = `${environment.apiEndpoint}/api/Autenticar/`;
      return true;
    },
      err => localStorage.removeItem("token"))
  }
}


// WEBPACK FOOTER //
// ./src/app/autenticacao/auth.guard.ts